import { defineStore } from "pinia";
import { type EnhanceOptions } from "../dto/enhance-signature.dto";

export interface EnhanceSignatureStoreState {
  map: Record<string, EnhanceOptions>;
}

export const useEnhanceSignatureStore = defineStore("enhance-signature", {
  state: (): EnhanceSignatureStoreState => ({ map: {} }),
  actions: {
    setOptions(key: number, optionKey: keyof EnhanceOptions, value: boolean) {
      const oldOptions = this.getOptions(key);
      this.map = { ...this.map, [key]: { ...oldOptions, [optionKey]: value } };
    },
  },
  getters: {
    getOptions(state: EnhanceSignatureStoreState) {
      return (key: number) => {
        return (
          state.map[key] || {
            name: false,
            date: false,
            job: false,
            city: false,
          }
        );
      };
    },
    getValue() {
      return (key: number, optionKey: keyof EnhanceOptions) => {
        return this.getOptions(key)[optionKey];
      };
    },
  },
  persist: true,
});
